/**
 * 售后订单路由模块
 */

import Layout from '@/layout/Layout.vue'

export default {
  path: '/after-sale',
  name: '售后',
  component: Layout,
  redirect: '/after-sale/after-sale',
  children: [
    {
      name: '售后订单',
      path: 'after-sale',
      component: () => import('@/views/afterSale/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'afterSale_after-sale'
      }
    },
    {
      name: '售后订单详情',
      path: 'after-sale/after-sale-order-details',
      component: () => import('@/views/afterSale/components/AfterSaleOrderDetails.vue'),
      meta: {
        father: {
          name: '售后订单',
          path: '/after-sale/after-sale'
        }
      }
    },
    {
      name: '新建退款订单',
      path: 'after-sale/add-after-sale-refund-order',
      component: () => import('@/views/afterSale/components/AddAfterSaleRefundOrder.vue'),
      meta: {
        father: {
          name: '售后订单',
          path: '/after-sale/after-sale'
        }
      }
    }
  ]
}
